import { DefaultValidator } from '..'
import { translateValidator } from '../../i18next/i18nextHelpers'
import { withDefaultValidator } from '../formValidators.utils'

const defaultTranslateKey = 'validator.biggerThanZero'

export const biggerThanZero = value => value > 0

export const biggerThanZeroTranslated: DefaultValidator = withDefaultValidator(
  (localeKey?: string) =>
    translateValidator(biggerThanZero, localeKey || defaultTranslateKey),
)
